module.exports = __webpack_public_path__ + "img/avatar.dfa35fd5.svg";